import { render, staticRenderFns } from "./updateChecklistModal.vue?vue&type=template&id=60d0c9d2&scoped=true"
import script from "./updateChecklistModal.vue?vue&type=script&lang=js"
export * from "./updateChecklistModal.vue?vue&type=script&lang=js"
import style0 from "./updateChecklistModal.vue?vue&type=style&index=0&id=60d0c9d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d0c9d2",
  null
  
)

export default component.exports